import FinishSignInContainer from './finish_sign_in_container';

const FinishSignIn = FinishSignInContainer;
export default FinishSignIn;
